import { IUser } from "../models/iuser";
import { ISite } from "../models/isite";

const siteObjectToQuery = (selectedSites: Array<ISite>) : string => {
    let siteIds = '';
    selectedSites.forEach((site, index) => {
        siteIds += `${index > 0 ? ',': ''}${site._id}`
    })
    return siteIds;
}

export default siteObjectToQuery;
